import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled/macro'
import { Card, Skeleton } from '../'

export default function AlbumList({ array }) {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (array.length > 0) {
      setIsLoading(false)
    }
  }, [array])
  const styles = { isLoading: isLoading }
  return (
    <OuterWrapper>
      <Grid styles={styles}>
        {isLoading
          ? Array.from({ length: 15 }).map((_, index) => (
              <Skeleton
                key={index}
                index={index}
              />
            ))
          : array.map((item, index) => (
              <Card
                key={index}
                {...item}
              />
            ))}
      </Grid>
    </OuterWrapper>
  )
}

const OuterWrapper = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  maxWidth: '950px',
  marginRight: 'auto',
  '@media (width < 1350px)': {
    marginRight: '0',
    maxWidth: 'unset',
  },
}))

const Grid = styled('section')(({ styles: { isLoading } }) => ({
  position: 'relative',
  display: 'grid',
  gridTemplateColumns: 'repeat( 3,300px)',
  width: '100%',
  placeItems: 'center',
  gap: '1.5rem',
  maxHeight: '673px',
  height: '673px',
  overflowY: 'auto',
  overflowX: 'hidden',
  maskImage: 'linear-gradient(to bottom, black 88%, transparent 100%)',
  WebkitMaskImage: 'linear-gradient(to bottom, black 88%, transparent 100%)',
  ' article:nth-of-type(12n + 1) ': {
    background: '#1e3265',
  },

  ' article:nth-of-type(12n + 2) ': {
    background: '#8300e7',
  },

  ' article:nth-of-type(12n + 3) ': {
    background: '#4f374f',
  },

  ' article:nth-of-type(12n + 4) ': {
    background: '#e9135d',
  },
  ' article:nth-of-type(12n + 5) ': {
    background: '#016450',
  },
  ' article:nth-of-type(12n + 6) ': {
    background: '#1d2f5d',
  },
  ' article:nth-of-type(12n + 7) ': {
    background: '#dc158c',
  },
  ' article:nth-of-type(12n + 8) ': {
    background: '#e51e31',
  },
  ' article:nth-of-type(12n + 9) ': {
    background: '#8e66ac',
  },
  ' article:nth-of-type(12n + 10) ': {
    background: '#0c73ec',
  },
  ' article:nth-of-type(12n + 11) ': {
    background: '#1e3265',
  },
  ' article:nth-of-type(12n + 12) ': {
    background: '#b06339',
  },
  '@media (width < 1350px)': {
    padding: '1rem ',
    maxHeight: 'unset',
    height: 'unset',
    overflowY: 'visible',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    maskImage: 'none',
    WebkitMaskImage: 'none',
  },
}))
